import { createSlice } from "@reduxjs/toolkit";
import { apiCallBegan } from "./api";
import { createSelector } from "reselect";
import { createAction } from "@reduxjs/toolkit";

const slice = createSlice({
  name: "insurers",
  initialState: {
    list: [],
    selectedInsurer: null,
    usercounts: null,
    isAddInsurerModalOpen: false,
    imgUpload: null,
    brokerageList: [],
  },
  reducers: {
    insurersReceived: (insurers, action) => {
      insurers.list = action.payload;
    },
    insurerSelected: (insurers, action) => {
      insurers.selectedInsurer = action.payload;
    },
    insurersDetailsReceived: (insurers, action) => {
      insurers.selectedInsurerDetails = action.payload;
    },
    insurersOptionsReceived: (insurers, action) => {
      insurers.options = action.payload;
    },
    insurersImgReceived: (insurers, action) => {
      insurers.imgUpload = action.payload;
    },
    insurersBLReceived: (insurers, action) => {
      insurers.brokerageList = action.payload;
    },
    insurerUserCountsAdded: (insurers, action) => {
      insurers.usercounts = action.payload;
    },
    AddInsurerModalToggled: (insurer, action) => {
      insurer.isAddInsurerModalOpen = action.payload.status;
    },
  },
});

export const {
  insurersReceived,
  insurersDetailsReceived,
  insurersOptionsReceived,
  insurersImgReceived,
  insurersBLReceived,
  insurerSelected,
  insurerUserCountsAdded,
  AddInsurerModalToggled,
} = slice.actions;

export default slice.reducer;

// action creator
export const loadInsurers = (data) =>
  apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: "/api/insurers",
    method: "get",
    data: data,
    onSuccess: insurersReceived.type,
  });

export const loadBrokerageInsurers = (data) =>
  apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: "/api/insurers/brokerage?code=" + data,
    method: "get",
    data: data,
    onSuccess: insurersReceived.type,
  });

export const loadProspectInsurers = (data) =>
  apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: "/api/insurers/prospect?code=" + data,
    method: "get",
    data: data,
    onSuccess: insurersReceived.type,
  });

export const getInsurerDetails = (data) =>
  apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: "/api/insurers/details?code=" + data,
    method: "get",
    onSuccess: insurersDetailsReceived.type,
  });

export const getInsurerOptions = () =>
  apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: "/api/insurers/options",
    method: "get",
    onSuccess: insurersOptionsReceived.type,
  });

export const addInsurer = (data) =>
  apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: "api/insurers/add",
    method: "post",
    data: data,
  });

export const updateInsurer = (data) =>
  apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: "api/insurers/update",
    method: "post",
    data: data,
  });

export const getInsBrokerageList = (data) =>
  apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: "/api/insurers/brokerages",
    method: "post",
    data: data,
    onSuccess: insurersBLReceived.type,
    onError: insurersBLReceived.type,
  });

// SAVE LOGO
export const saveLogo = (data) =>
  apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: "api/insurers/uploadlogo",
    method: "post",
    data: data,
    onSuccess: insurersImgReceived.type,
  });

export const getInsurersList = createSelector(
  (state) => state.entities.insurers,
  (insurers) => insurers?.list
);

export const getInsurersUserCounts = createSelector(
  (state) => state.entities.insurers,
  (insurers) => insurers?.usercounts
);

export const getSelectedInsurer = createSelector(
  (state) => state.entities.insurers,
  (insurers) => insurers?.selectedInsurer
);

export const getSelectedInsurerDetails = createSelector(
  (state) => state.entities.insurers,
  (insurers) => insurers?.selectedInsurerDetails
);

export const toggleAddInsurerModal = createAction(
  AddInsurerModalToggled.type,
  function toggle(toggleFlag) {
    return {
      payload: {
        status: toggleFlag,
      },
    };
  }
);

export const getAddInsurerStatus = createSelector(
  (state) => state.entities.insurers,
  (insurers) => insurers?.isAddInsurerModalOpen
);

export const getInsurerBrokerList = createSelector(
  (state) => state.entities.insurers,
  (insurers) => insurers?.brokerageList
);

export const getImgInsurerStatus = createSelector(
  (state) => state.entities.insurers,
  (insurers) => insurers?.imgUpload
);

export const getInsurerOptionsList = createSelector(
  (state) => state.entities.insurers,
  (insurers) => insurers?.options
);
